import React from "react";

/**
 * Brand-accurate inline SVG icons for payment platforms.
 * Lightweight (~2KB), no dependency, scales with `size`.
 *
 * Usage:  <PaymentBrand name="paypal" className="h-8 w-8" />
 */

const Brands = {
  cashapp: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#00D632" />
      <path
        fill="#fff"
        d="M40.6 22.5c-1-1-2.5-1.7-4.2-1.8-2.1-.1-4.2.5-5.8 1.7-.4.3-1 .3-1.4-.1l-1.6-1.7a1 1 0 0 1 .1-1.4 12 12 0 0 1 5.4-2.5l.5-2.2c.1-.5.5-.8 1-.8h2.3c.6 0 1.1.5 1 1.1l-.5 2.1c1.4.4 2.6 1.1 3.7 2.1.4.4.4 1 0 1.4l-1.4 1.4c-.3.4-1 .4-1.4 0zM23.4 41.5c1 1 2.5 1.7 4.2 1.8 2.1.1 4.2-.5 5.8-1.7.4-.3 1-.3 1.4.1l1.6 1.7c.4.4.4 1-.1 1.4a12 12 0 0 1-5.4 2.5l-.5 2.2c-.1.5-.5.8-1 .8h-2.3c-.6 0-1.1-.5-1-1.1l.5-2.1a10 10 0 0 1-3.7-2.1c-.4-.4-.4-1 0-1.4l1.4-1.4c.3-.4 1-.4 1.4 0zM30.2 38.7c-1.7-.3-3.3-1-4.6-2.1a1 1 0 0 1-.1-1.5l1.6-1.7c.4-.4 1-.4 1.4-.1 1.1 1 2.6 1.6 4.2 1.6 1.6 0 3-.7 3-2.1 0-1.3-1.4-1.9-3.7-2.7-3.4-1.1-7.2-2.5-7.2-7 0-3.7 3-6.4 7.7-6.4l.5-2.1c.1-.5.5-.9 1-.9h2.3c.6 0 1.1.5 1 1.1l-.5 2.1c1.6.3 3.2 1 4.5 2 .4.3.5 1 .1 1.4l-1.5 1.7c-.3.4-.9.4-1.3.1a6 6 0 0 0-3.8-1.4c-1.7 0-2.8.7-2.8 1.8 0 1.3 1.4 1.8 4 2.7 3.6 1.2 7 2.8 7 7.1 0 4-3.1 6.5-7.8 6.5z"
      />
    </svg>
  ),
  paypal: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#003087" />
      <path
        fill="#009cde"
        d="M44.2 20.8c.7 4.2-1.2 7.6-4 9.8-2.8 2.2-6.7 3-10.7 3h-1.8c-.6 0-1.1.4-1.2 1l-1.6 8.5-.4 2.5c-.1.6-.6 1-1.2 1H19c-.5 0-.8-.4-.7-.9l3.8-19.4c.2-.9.9-1.5 1.8-1.5h7.4c4.7 0 8.7 1.4 11 4.5.3.4.6.9.9 1.5h1z"
      />
      <path
        fill="#fff"
        d="M40.8 18c1 2.4 1.1 5 .4 7.7-1.4 5.6-5.7 8.5-12.4 8.5h-1.7c-.6 0-1.2.4-1.3 1l-1.7 8.6h-5.1l3.9-20c.2-.9.9-1.6 1.9-1.6h7.6c4.4 0 7.4 1.3 8.4 4-.1.6 0 1.2 0 1.8z"
      />
    </svg>
  ),
  venmo: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#3D95CE" />
      <path fill="#fff" d="M45.3 15.7c1 1.6 1.5 3.3 1.5 5.5 0 6.9-5.9 15.8-10.7 22.1H24.3l-4.5-26.8 9.7-1 2.4 19.3c2.2-3.6 5-9.4 5-13.3 0-2.1-.4-3.6-.9-4.8l9.3-1z" />
    </svg>
  ),
  zelle: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#6D1ED4" />
      <path fill="#fff" d="M29.8 12.6h4.4c.5 0 .9.4.9.9v3.6h6.2c.5 0 .9.4.9.9v3a1 1 0 0 1-.2.6L25.9 41.6h15.5c.5 0 .9.4.9.9v3.4c0 .5-.4.9-.9.9h-6.4v3.6c0 .5-.4.9-.9.9h-4.4a1 1 0 0 1-.9-.9v-3.6h-6.6a1 1 0 0 1-.9-.9v-3.1c0-.2 0-.4.2-.6l16.1-19.9H22a1 1 0 0 1-.9-.9V18c0-.5.4-.9.9-.9h6.8v-3.6c0-.5.4-.9.9-.9z" />
    </svg>
  ),
  stripe: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#635BFF" />
      <path fill="#fff" d="M30.7 25c0-1.8 1.5-2.5 3.9-2.5 3.5 0 7.8 1 11.2 2.9V14.7a30 30 0 0 0-11.2-2c-9.2 0-15.3 4.8-15.3 12.8 0 12.6 17.3 10.6 17.3 16 0 2.1-1.8 2.8-4.3 2.8-3.7 0-8.5-1.6-12.4-3.7v10.9c4.3 1.9 8.6 2.6 12.4 2.6 9.4 0 15.8-4.7 15.8-12.8 0-13.5-17.4-11.1-17.4-16.3z" />
    </svg>
  ),
  bank: ({ size = 28, className = "" }) => (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#0F1A2B" />
      <path fill="#C9A44C" d="M32 10 12 22h40zM14 25h6v18h-6zm10 0h6v18h-6zm10 0h6v18h-6zm10 0h6v18h-6zM12 46h40v4H12z" />
    </svg>
  ),
};

const PaymentBrand = ({ name, size, className }) => {
  const Icon = Brands[name?.toLowerCase()];
  if (!Icon) return null;
  return <Icon size={size} className={className} />;
};

export default PaymentBrand;
